import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { MenuButtonWrapper, SideContainer, SideMenuContainer } from './SideMenu.style';

export interface MenuItemsType {
    id: string;
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
    activeParams?: string[];
}

interface SideMenuPropsType {
    sideLinks: Array<MenuItemsType>;
}

interface IsMenuButtonActiveParamsType {
    param: string | null;
    linkItem: MenuItemsType;
}

const isMenuButtonActive = ({ param, linkItem }: IsMenuButtonActiveParamsType): boolean => {
    if (param === null) return false;

    if (linkItem.id === param) return true;

    return linkItem.activeParams !== undefined && linkItem.activeParams.includes(param);
};

export const SideMenu = observer(({ sideLinks }: SideMenuPropsType): JSX.Element | null => {
    const { routerBackoffice } = useAppStateContext();

    const paramObj = routerBackoffice.getParametersAllFromNamespace('global');
    const paramKeys = Object.keys(paramObj);
    const paramKey = paramKeys[0];
    const param = routerBackoffice.getParametersString('global', paramKey ?? '');

    return (
        <SideMenuContainer data-test='side-menu-root'>
            <SideContainer>
                {sideLinks.map((linkItem) => (
                    <MenuButtonWrapper
                        key={linkItem.id}
                        isActive={isMenuButtonActive({ param, linkItem })}
                        onClick={linkItem.onClick}
                    >
                        {linkItem.label}
                    </MenuButtonWrapper>
                ))}
                {/* TODO ADD THIS MENU TO CMS BUTTON IN MENU */}
                {/* <SubSectionsMenu param={param} /> */}
            </SideContainer>
        </SideMenuContainer>
    );
});
